import SearchJobsButton from './search-jobs-button'

export default SearchJobsButton
